/**
 * 백엔드가 내려준 검증 메시지를 그대로 꺼낸다.
 * (ApiResponseMessage 의 data 또는 errorMessage 필드)
 */
export function errorText(err, fallback = '처리에 실패했습니다.') {
  if (err && err.response && err.response.data) {
    const body = err.response.data;
    if (typeof body.data === 'string' && body.data) {
      return body.data;
    }
    if (body.errorMessage) {
      return body.errorMessage;
    }
  }
  return fallback;
}
